import { ERROR } from "constant/message";
import { MODULE_ENTITE } from "constant/moduleInfo";
import useArrayOperation from "hooks/useArrayOperation";

const { sortArray } = useArrayOperation();
const getEntity = async (getData) => {
  const fetchData = await getData(MODULE_ENTITE);
  let result = [];
  if (fetchData !== ERROR) {
    result = sortArray(fetchData, "name");
  }
  return result;
};
export default getEntity;
